module.exports = __webpack_public_path__ + "img/Union.13cebc49.svg";